import { Fragment, ReactElement } from 'react';

export type FormItemLabelProps = {
  label?: string | ReactElement;
  showTips?: boolean;
  onTips?: () => void;
};

export const FormItemLabel = (props: FormItemLabelProps) => {
  return (
    <Fragment>
      {props.label && (
        <label>
          {props.label}
          {props.showTips && <span className="v-form-item-label-tips" onClick={props.onTips}></span>}
        </label>
      )}
    </Fragment>
  );
};
